import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import {
  MarketplacePaymentClient,
  MarketplacePaymentLineQuery,
} from 'src/WebApiController';

import { useFilterQueryContext } from '../FilterQueryContext';

export const GET_PAYMENT_LINES_WITH_SALES_BY_FILTERS_QUERY_KEY =
  'MarketplacePaymentClient.getPaymentLinesWithSalesByFilters';

export const useGetMarketplacePaymentLinesWithSalesByFilters = (
  marketplacePaymentId: number,
  disabled: boolean
) => {
  const { activeAccountWebClientConfig } = useAppContext();

  const { trackError } = useClientLogContext();
  const { filterQuery } = useFilterQueryContext<MarketplacePaymentLineQuery>();

  const shouldQuery =
    !disabled &&
    activeAccountWebClientConfig.activeAccountId != null &&
    !!marketplacePaymentId;

  const paymentLineQuery = useQuery({
    queryKey: [
      GET_PAYMENT_LINES_WITH_SALES_BY_FILTERS_QUERY_KEY,
      activeAccountWebClientConfig.activeAccountId,
      filterQuery,
    ],
    queryFn: async () => {
      if (!shouldQuery) {
        return null;
      }
      return await new MarketplacePaymentClient(
        activeAccountWebClientConfig
      ).getPaymentLinesWithSalesByFilters(filterQuery, marketplacePaymentId);
    },

    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError(
          'MarketplacePaymentClient.getPaymentLinesWithSalesByFilters',
          error,
          {
            marketplacePaymentId,
          }
        );
      },
    },
    enabled: shouldQuery,
  });

  return { paymentLineQuery };
};
